import { PartyCharacteristic } from "./party-characteristic";
import { PartySpecification } from "./partySpecifications";

import { Role } from "./role";

export class PartyManagerMapper {

    static getCharacteristicsFromApi(data:any):PartyCharacteristic[]{
        let characteristics:PartyCharacteristic[]=[] 
        let characteristicsApi = data['describedByList']
        for(let characteristicApi of characteristicsApi){
            let value:string = characteristicApi['value'];
            let partyRef = characteristicApi['partyCharRef'];
            characteristics.push({ 
                partyCharRef :{
                    name: partyRef['name'],
                    namingId:partyRef['namingId']
                },
                value:value
            }
            )
        }
        return characteristics;
       }
    
       static getRoles(data:any):Role[]{
            let roles:Role[]=[];
            let rolesApi = data['allowedRoles'];
            for(let roleApi of rolesApi){
                roles.push({ id:roleApi['id'],name:roleApi['name'],description: roleApi['description']} as Role);
            }
            return roles;
       }

       static getPartyCharacteristicFromApi(data:any): PartyCharacteristic{
           
        let namingIdRefSplit:string[] = data['_links']['partyCharacteristic']['href'].split("/")
        let namingId = namingIdRefSplit[namingIdRefSplit.length-1]
        return { 
            partyCharRef :{
                name: data['name'],
                namingId:namingId
            }
        };
    }

    static getPartySpecificationFromApi(data: any):PartySpecification{
        let name = data['name']
        let version = data['version']
        let namingIdRef:string = data['_links']['describedByList']['href']
        let namingIdRefSplit = namingIdRef.split("/")
        let namingId = namingIdRefSplit[namingIdRefSplit.length-2]
        return {
            version:version, 
            namingId:namingId,
            name:name
        };
    }
}